document.addEventListener("DOMContentLoaded", function () {
  const widget = document.querySelector(".product-widget");
  if (!widget) return;

  // Collect data from HTML attributes
  const productTitle = widget.getAttribute("data-title");
  const productImage = widget.getAttribute("data-image");
  const currentPrice = widget.getAttribute("data-current-price");
  const originalPrice = widget.getAttribute("data-original-price");
  const discountText = widget.getAttribute("data-discount-text");
  const variantId = widget.getAttribute("data-variant-id");
  const sku = widget.getAttribute("data-sku");
  const category = widget.getAttribute("data-category");
  const blogSource = widget.getAttribute("data-blog-source") || "unknown";

  // Populate widget content
  document.getElementById("productTitle").innerText = productTitle;
  document.getElementById("productImage").src = productImage;
  document.getElementById("currentPrice").innerText = "₹" + currentPrice;
  document.getElementById("originalPrice").innerText = "₹" + originalPrice;
  document.getElementById("discountText").innerText = discountText;

  // Force square image
  const imgEl = document.getElementById("productImage");
  imgEl.style.width = "100%";
  imgEl.style.aspectRatio = "1 / 1";
  imgEl.style.objectFit = "cover";
  imgEl.style.borderRadius = "12px";

  // Add-to-cart logic
  document.getElementById("addToCartBtn").addEventListener("click", function () {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1
          }
        ],
        attributes: {
          blog_source: blogSource,
          blog_widget: "true"
        }
      })
    })
      .then(res => res.json())
      .then(data => {
        document.getElementById("cartFeedback").innerText = "Added to cart! Redirecting...";

        // Push event to GA4
        if (typeof gtag === "function") {
          gtag("event", "add_to_cart", {
            currency: "INR",
            value: currentPrice,
            items: [
              {
                item_id: sku,
                item_name: productTitle,
                item_category: category,
                price: currentPrice,
                quantity: 1,
                blog_source: blogSource
              }
            ]
          });
        }

        // Redirect to cart with UTM parameters for GA4 attribution
        setTimeout(() => {
          window.location.href =
            "/cart?utm_source=blog&utm_medium=widget&utm_campaign=" + encodeURIComponent(blogSource);
        }, 800);
      })
      .catch(err => {
        document.getElementById("cartFeedback").innerText = "Error adding to cart. Please try again.";
        console.error(err);
      });
  });
});
